export const ptBRGrid = {
  // Column menu texts
  columnMenuUnsort: "Sem ordenação",
  columnMenuSortAsc: "Ordenar crescente",
  columnMenuSortDesc: "Ordenar decrescente",
  columnMenuFilter: "Filtrar",
  columnMenuHideColumn: "Ocultar coluna",
  columnMenuShowColumns: "Mostrar colunas",

  // Header texts
  columnsPanelTextFieldLabel: "Buscar coluna",
  columnsPanelShowAllButton: "Mostrar todas",
  columnsPanelHideAllButton: "Ocultar todas",

  // Filter texts
  filterPanelAddFilter: "Adicionar filtro",
  filterPanelDeleteIconLabel: "Excluir",
  filterPanelOperators: "Operadores",
  filterPanelOperatorAnd: "E",
  filterPanelOperatorOr: "Ou",
  filterPanelColumns: "Colunas",
  filterPanelInputLabel: "Valor",
  filterPanelInputPlaceholder: "Filtrar valor",

  // Pagination
  footerRowSelected: (count) =>
    count > 1
      ? `${count.toLocaleString()} boletos selecionados`
      : `${count.toLocaleString()} boleto selecionado`,
  footerTotalRows: "Total de boletos:",
  footerPaginationRowsPerPage: "Boletos por página:",
  MuiTablePagination: {
    labelRowsPerPage: "Boletos por página:",
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`,
  },

  // No data
  noRowsLabel: "Nenhum boleto encontrado",
  noResultsOverlayLabel: "Nenhum boleto encontrado",

  // Toolbar
  toolbarDensity: "Densidade",
  toolbarDensityLabel: "Densidade",
  toolbarDensityCompact: "Compacta",
  toolbarDensityStandard: "Padrão",
  toolbarDensityComfortable: "Confortável",
  toolbarColumns: "Colunas",
  toolbarColumnsLabel: "Selecionar colunas",
  toolbarFilters: "Filtros",
  toolbarFiltersLabel: "Mostrar filtros",
  toolbarFiltersTooltipHide: "Ocultar filtros",
  toolbarFiltersTooltipShow: "Mostrar filtros",
  toolbarExport: "Exportar",
  toolbarExportLabel: "Exportar",
  toolbarExportCSV: "Download como CSV",
  toolbarExportPrint: "Imprimir",

  // Column grouping
  groupingColumnHeaderName: "Grupo",
  groupColumn: (name) => `Agrupar por ${name}`,
  unGroupColumn: (name) => `Remover agrupamento por ${name}`,

  // Column header
  columnsPanelTextFieldPlaceholder: "Título da coluna",

  // Error messages
  errorOverlayDefaultLabel: "Ocorreu um erro.",
};
